import React from "react";
import Text from "../../../../../shared/components/Text";
import { postalCodeValidation } from "./postalCodeValidation";

export const AddressValidationRules = {
  requiredField: {
    required: {
      value: true,
      message: <Text tId={"REQUIRED_FIELD"} />,
    },
  },
  maxLengthValidation: (required, maxLength) => ({
    required: {
      value: required,
      message: <Text tId={"REQUIRED_FIELD"} />,
    },
    validate: {
      maxLength: (value) => {
        if (value && value.length > maxLength)
          return (
            <Text
              tId={"FIELD_VALUE_MUST_BE_BELOW_X_CHAR"}
              dynamicDataTexts={[maxLength]}
            />
          );
        return true;
      },
    },
  }),
  streetNumberValidation: (required, maxLength) => ({
    required: {
      value: required,
      message: <Text tId={"REQUIRED_FIELD"} />,
    },
    validate: {
      maxLengthAndNoSpaces: (value) => {
        if (value && value.length > maxLength) {
          return (
            <Text
              tId={"FIELD_VALUE_MUST_BE_BELOW_X_CHAR"}
              dynamicDataTexts={[maxLength]}
            />
          );
        }
        if (value && value.includes(" "))
          return <Text tId={"FIELD_VALUE_MUST_NOT_CONTAIN_SPACES"} />;
        return true;
      },
    },
  }),
  postalCode: (country) => ({
    required: {
      value: true,
      message: <Text tId={"REQUIRED_FIELD"} />,
    },
    validate: {
      validPostalCode: (value) => {
        if (!postalCodeValidation(country, value))
          return <Text tId={"INVALID_POSTAL_CODE"} />;
        return true;
      },
    },
  }),
};
